import axios from 'axios'
import store from '@/store/index.js'
import jwtDecode from 'jwt-decode'

export default function setup () {
  // attaches the userToken to every request if it exists, and refreshes it if needed
  axios.interceptors.request.use(async function (config) {
    if (config.url.match(/refresh$/)) {
      return config
    }
    if (store.state.userToken) {
      const expireTime = new Date(jwtDecode(store.state.userToken).exp * 1000)
      const bufferTime = new Date()
      bufferTime.setSeconds(bufferTime.getSeconds() + 30)
      const userTokenIsExpired = expireTime <= bufferTime
      if (userTokenIsExpired) {
        await store.dispatch('setToken')
      }
      config.headers.Authorization = store.state.userToken
      return config
    } else {
      return config
    }
  }, function (err) {
      return Promise.reject(err)
  },
)

  axios.interceptors.response.use(
    response => response,
    err => {
      if (err.response.status === 401 || err.response.status === 403 || err.response.status === undefined) {
        store.dispatch('logout')
      } else {
        if (err.response.data.detail) {
          const payload = { type: 'error', text: err.response.data.detail, unread: true }
          store.dispatch('updateMessages', payload, { root: true })
        }
        throw err
      }
    },
  )
}
